import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAPIError from '../../../hooks/useAPIError';
import DataService from '../../../services/MisDatosService';
import { useAuthStore as useAuthStoreEroski } from '../../../store/AuthContext';
import { BajaMotivos } from '../../../types/PersonalData';
import { SessionChecker } from '../../../utils/SessionChecker';
import IconBack from '../../../Icons/IconBack';
import { HostProvider } from '../../../utils/HostProvider';
import { FrontMappings } from '../../../utils/FrontMappings';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  isDigital: boolean;
  isEroski: boolean;
  setShowGraciasForm: (show: boolean) => void;
  setShowBajaForm: (show: boolean) => void;
}

const EncuestaForm: FC<Props> = (props) => {
  const {
    visible,
    setVisible,
    isEroski,
    setShowGraciasForm,
    setShowBajaForm,
  } = props;
  let { isDigital } = props;

  const dataUser = useAuthStoreEroski();
  const { t } = useTranslation();
  const [load, setLoad] = useState<boolean>(false);
  const [showOption1, setShowOption1] = useState<boolean>(false);
  const [showOption2, setShowOption2] = useState<boolean>(false);
  const [showOption5, setShowOption5] = useState<boolean>(false);
  const [showInternalOption1, setInternalOption1] = useState<boolean>(false);
  const [showInternalOption2, setInternalOption2] = useState<boolean>(false);
  const [cadena1, setCadena1] = useState<string>('');
  const [cadena2, setCadena2] = useState<string>('');
  const [cadena3, setCadena3] = useState<string>('');
  const [motivos, setMotivos] = useState<BajaMotivos>({
    version: '',
    fromApp: '',
    bajaCompletada: true,
    bajaDigitalYClub: false,
    checkNoUtilizo: 0,
    checkNoUtilizoNoCompro: 0,
    checkNoUtilizoUsoPuntual: 0,
    checkNoUtilizoNoServiciosClub: 0,
    checkNoUtilizoNoDigital: 0,
    checkNoUtilizoOtros: 0,
    textNoUtilizoOtros: '',
    checkMalaExperiencia: 0,
    checkMalaExperienciaTiendaOnline: 0,
    checkMalaExperienciaApp: 0,
    checkMalaExperienciaWeb: 0,
    checkMalaExperienciaOtros: 0,
    textMalaExperienciaOtros: '',
    checkDemasiadaComunicacion: 0,
    checkDatosPersonales: 0,
    checkOtrosMotivos: 0,
    textOtrosMotivos: '',
  });
  const { addError, addErrorBack } = useAPIError();

  const inizializarFormulario = () => {
    setShowOption1(false);
    setShowOption2(false);
    setShowOption5(false);
    setCadena1('');
    setCadena2('');
    setCadena3('');
    setInternalOption1(false);
    setInternalOption2(false);
    setMotivos({
      version: '',
      fromApp: '',
      bajaCompletada: true,
      bajaDigitalYClub: false,
      checkNoUtilizo: 0,
      checkNoUtilizoNoCompro: 0,
      checkNoUtilizoUsoPuntual: 0,
      checkNoUtilizoNoServiciosClub: 0,
      checkNoUtilizoNoDigital: 0,
      checkNoUtilizoOtros: 0,
      textNoUtilizoOtros: '',
      checkMalaExperiencia: 0,
      checkMalaExperienciaTiendaOnline: 0,
      checkMalaExperienciaApp: 0,
      checkMalaExperienciaWeb: 0,
      checkMalaExperienciaOtros: 0,
      textMalaExperienciaOtros: '',
      checkDemasiadaComunicacion: 0,
      checkDatosPersonales: 0,
      checkOtrosMotivos: 0,
      textOtrosMotivos: '',
    });
  };

  useEffect(() => {
    if (dataUser.user.token !== '') setLoad(true);
  }, [dataUser.user.token]);

  const ContarLetras = (
    k: React.ChangeEvent<HTMLTextAreaElement>,
    id: number,
  ) => {
    if (id === 1) {
      setCadena1('');
      if (cadena1.length <= 300) setCadena1(k.target.value);
    }
    if (id === 2) {
      setCadena2('');
      if (cadena2.length <= 300) setCadena2(k.target.value);
    }
    if (id === 3) {
      setCadena3('');
      if (cadena3.length <= 300) setCadena3(k.target.value);
    }
  };

  const correctMotivosNoUtilizo = () => {
    if (motivos.checkNoUtilizo === 0) {
      motivos.checkNoUtilizoNoDigital = 0;
      motivos.checkNoUtilizoNoServiciosClub = 0;
      motivos.checkNoUtilizoUsoPuntual = 0;
      motivos.checkNoUtilizoOtros = 0;
      motivos.textNoUtilizoOtros = '';
      motivos.checkNoUtilizoNoCompro = 0;
      setMotivos(motivos);
    } else if (motivos.checkNoUtilizoOtros === 0) {
      motivos.textNoUtilizoOtros = '';
      setMotivos(motivos);
    }
  };

  const correctMotivosMalaExperiencia = () => {
    if (motivos.checkMalaExperiencia === 0) {
      motivos.checkMalaExperienciaApp = 0;
      motivos.checkMalaExperienciaTiendaOnline = 0;
      motivos.checkMalaExperienciaWeb = 0;
      motivos.checkMalaExperienciaOtros = 0;
      motivos.textMalaExperienciaOtros = '';
      setMotivos(motivos);
    } else if (motivos.checkMalaExperienciaOtros === 0) {
      motivos.textMalaExperienciaOtros = '';
      setMotivos(motivos);
    }
  };

  const correctOtrosMotivos = () => {
    if (!showOption5) {
      motivos.textOtrosMotivos = '';
      motivos.checkOtrosMotivos = 0;
      setMotivos(motivos);
    }
  };

  const correctMotivos = () => {
    correctMotivosNoUtilizo();
    correctMotivosMalaExperiencia();
    correctOtrosMotivos();
  };

  const handlerChange = (
    value: React.ChangeEvent<HTMLInputElement>,
    key: string,
  ) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'NoUsoNoCompro':
        setMotivos({
          ...motivos,
          checkNoUtilizoNoCompro: value.target.checked ? 1 : 0,
        });
        break;
      case 'NoUsoUsoPuntual':
        setMotivos({
          ...motivos,
          checkNoUtilizoUsoPuntual: value.target.checked ? 1 : 0,
        });
        break;
      case 'NoUsoNoServiciosClub':
        setMotivos({
          ...motivos,
          checkNoUtilizoNoServiciosClub: value.target.checked ? 1 : 0,
        });
        break;
      case 'NoUsoNoDigital':
        setMotivos({
          ...motivos,
          checkNoUtilizoNoDigital: value.target.checked ? 1 : 0,
        });
        break;
      case 'MalaExpTiendaOnline':
        setMotivos({
          ...motivos,
          checkMalaExperienciaTiendaOnline: value.target.checked ? 1 : 0,
        });
        break;
      case 'MalaExpApp':
        setMotivos({
          ...motivos,
          checkMalaExperienciaApp: value.target.checked ? 1 : 0,
        });
        break;
      case 'MalaExpWeb':
        setMotivos({
          ...motivos,
          checkMalaExperienciaWeb: value.target.checked ? 1 : 0,
        });
        break;
      case 'DemasiadaComunicacion':
        setMotivos({
          ...motivos,
          checkDemasiadaComunicacion: value.target.checked ? 1 : 0,
        });
        break;
      case 'DatosPersonales':
        setMotivos({
          ...motivos,
          checkDatosPersonales: value.target.checked ? 1 : 0,
        });
        break;
      case 'NoUtilizoOtros':
        setMotivos({
          ...motivos,
          checkNoUtilizoOtros: value.target.checked ? 1 : 0,
        });
        setInternalOption1(value.target.checked);
        break;
      case 'MalaExpOtros':
        setMotivos({
          ...motivos,
          checkMalaExperienciaOtros: value.target.checked ? 1 : 0,
        });
        break;
      case 'OtrosMotivos':
        setMotivos({
          ...motivos,
          checkOtrosMotivos: value.target.checked ? 1 : 0,
        });
        break;
    }
  };

  const GuardarNoBaja = () => {
    correctMotivos();
    document.body.classList.remove('fix');
    motivos.bajaCompletada = false;
    DataService.bajaDigital(motivos).then((response) => {
      if (response.data.error) {
        addErrorBack(response.data);
      }
    });
    inizializarFormulario();
    setVisible(false);
    setShowBajaForm(false);
  };

  const DarBaja = () => {
    if (!isDigital) {
      const url = window.location.pathname;
      if (url.includes(FrontMappings.BAJA_DIGITAL)) {
        isDigital = true;
      }
    }
    correctMotivos();
    if (isDigital && !isEroski) {
      const fromApp =
        dataUser.user.fromApp === undefined ? '' : dataUser.user.fromApp;
      DataService.logoutUserForBaja(fromApp);
      DataService.bajaDigital(motivos)
        .then((response) => {
          if (response.data.error) {
            addErrorBack(response.data);
          } else {
            SessionChecker.closeSesion(null);
            setShowGraciasForm(true);
            inizializarFormulario();
          }
        })
        .catch((e) => {
          console.log(e);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        });
    }
    if (isEroski && !isDigital) {
      DataService.bajaEroskiClub(motivos)
        .then((response) => {
          if (response.data.error) {
            addErrorBack(response.data);
          } else {
            setShowGraciasForm(true);
            inizializarFormulario();
          }
        })
        .catch((e) => {
          console.log(e);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        });
    }
    if (isDigital && isEroski) {
      const fromApp =
        dataUser.user.fromApp === undefined ? '' : dataUser.user.fromApp;
      DataService.logoutUserForBaja(fromApp);
      motivos.bajaDigitalYClub = true;
      DataService.bajaEroskiClub(motivos)
        .then((response) => {
          if (response.data.error) {
            addErrorBack(response.data);
          } else {
            SessionChecker.closeSesion(null);
            setShowGraciasForm(true);
            inizializarFormulario();
          }
        })
        .catch((e) => {
          console.log(e);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        });
    }
  };

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      const element = document.getElementById('section') as HTMLElement;
      element.removeEventListener('keydown', saveInfo, false);

      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.getElementById('baja-confirm-btn').click();
    }
  };
  useEffect(() => {
    const element = document.getElementById('section') as HTMLElement;
    if (visible && load) {
      element.setAttribute('tabindex', '0');
      element.focus();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      element.addEventListener('keydown', saveInfo, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const goBack = () => {
    inizializarFormulario();
    setVisible(false);
  };

  return (
    <>
      {(() => {
        if (load) {
          return (
            <>
              <section
                id="section"
                className={`o-section--large form-encuesta bloque-form ${
                  visible ? 'visible' : ''
                }`}
              >
                <div className="container u-margin-top-hero">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <a
                    className="link-prev"
                    onClick={() => {
                      goBack();
                    }}
                  >
                    <div className="icon icon-medium">
                      <IconBack />
                    </div>
                    <p className="u-font-normal u-text-brand u-margin-left">
                      {t('datos.baja.back')}
                    </p>
                  </a>

                  <h2 className="bloque-datos__title u-text-brand">
                    <span className="divider__square brand-color" />
                    <span className="u-margin-right">
                      {t('datos.baja.opinion-matters')}
                    </span>
                  </h2>
                  <p>{t('datos.baja.unsubscribe-body-third-line')}</p>
                  <p className="u-margin-bottom">{t('datos.baja.thanks')}</p>
                  <form method="post">
                    <fieldset>
                      <legend className="hidden">
                        {t('datos.baja.select-motive')}
                      </legend>

                      <div className="checkbox">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="checkgroup label--background">
                          {t('datos.baja.no-use')}
                          <input
                            type="checkbox"
                            id="motivo-one"
                            className="open"
                            checked={showOption1}
                            onChange={(e) => {
                              setShowOption1(e.target.checked);
                              setMotivos({
                                ...motivos,
                                checkNoUtilizo: e.target.checked ? 1 : 0,
                              });
                            }}
                          />
                          <span className="checkmark" />
                        </label>
                      </div>

                      <div
                        className={`u-border-all--grey-lighter u-padding ${
                          !showOption1 ? 'u-display-none' : ''
                        }`}
                      >
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="checkgroup checkgroup__block">
                          {t('datos.baja.no-buy')}{' '}
                          {HostProvider.isEroski() && (
                            <span className="u-text-transform-uppercase">
                              {t('datos.baja.eroski-encuesta')}.
                            </span>
                          )}
                          {HostProvider.isCaprabo() && (
                            <span> {t('caprabo.baja.caprabo')}.</span>
                          )}
                          <input
                            type="checkbox"
                            id="no-compro"
                            checked={
                              motivos.checkNoUtilizoNoCompro !== 0 &&
                              showOption1
                            }
                            onChange={(e) => handlerChange(e, 'NoUsoNoCompro')}
                          />
                          <span className="checkmark" />
                        </label>

                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="checkgroup checkgroup__block">
                          {t('datos.baja.no-matters-to-me')}

                          <input
                            type="checkbox"
                            id="algo-puntual"
                            checked={
                              motivos.checkNoUtilizoUsoPuntual !== 0 &&
                              showOption1
                            }
                            onChange={(e) =>
                              handlerChange(e, 'NoUsoUsoPuntual')
                            }
                          />
                          <span className="checkmark" />
                        </label>

                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="checkgroup checkgroup__block">
                          {t('datos.baja.no-use-services')}{' '}
                          {HostProvider.isEroski() && (
                            <>
                              <span className="u-text-transform-uppercase">
                                {t('datos.baja.eroski-encuesta')}
                              </span>{' '}
                              {t('datos.baja.club')}
                            </>
                          )}
                          {HostProvider.isCaprabo() && (
                            <span>{t('caprabo.baja.club-caprabo')}</span>
                          )}
                          <input
                            type="checkbox"
                            id="no-utilizo"
                            checked={
                              motivos.checkNoUtilizoNoServiciosClub !== 0 &&
                              showOption1
                            }
                            onChange={(e) =>
                              handlerChange(e, 'NoUsoNoServiciosClub')
                            }
                          />
                          <span className="checkmark" />
                        </label>
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="checkgroup checkgroup__block">
                          {t('datos.baja.no-use-digital-channels')}{' '}
                          {HostProvider.isEroski() && (
                            <span className="u-text-transform-uppercase">
                              {t('datos.baja.eroski-encuesta')}
                            </span>
                          )}
                          {HostProvider.isCaprabo() && (
                            <span>{t('caprabo.baja.caprabo')}</span>
                          )}
                          <input
                            type="checkbox"
                            id="no-digital"
                            checked={
                              motivos.checkNoUtilizoNoDigital !== 0 &&
                              showOption1
                            }
                            onChange={(e) => handlerChange(e, 'NoUsoNoDigital')}
                          />
                          <span className="checkmark" />
                        </label>
                        <div className="checkbox">
                          <label
                            className="checkgroup checkgroup__block otros"
                            htmlFor="otros2"
                          >
                            {t('datos.baja.others')}

                            <input
                              type="checkbox"
                              id="otros2"
                              className="open"
                              checked={
                                motivos.checkNoUtilizoOtros !== 0 && showOption1
                              }
                              readOnly
                              onChange={(e) =>
                                handlerChange(e, 'NoUtilizoOtros')
                              }
                              onClick={() => {
                                setInternalOption1(!showInternalOption1);
                              }}
                            />
                            <span className="checkmark" />
                          </label>
                        </div>
                        <div
                          className={`text-otros-motivos u-padding-top ${
                            !showInternalOption1 ? 'u-display-none' : ''
                          }`}
                        >
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label className="hidden">
                            {t('datos.baja.others-motives')}
                          </label>
                          <span className="num-caracteres">
                            {cadena1.length}/300
                          </span>
                          <textarea
                            className="textarea"
                            maxLength={300}
                            placeholder={t('datos.baja.tell-us')}
                            cols={100}
                            id="otros-motivos"
                            rows={4}
                            value={cadena1}
                            onChange={(event) => {
                              ContarLetras(event, 1);
                              setMotivos({
                                ...motivos,
                                textNoUtilizoOtros: event.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>

                      <div className="checkbox">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="checkgroup label--background">
                          {t('datos.baja.bad-experience')}
                          <input
                            type="checkbox"
                            id="motivo-two"
                            className="open"
                            checked={showOption2}
                            onChange={(e) => {
                              setShowOption2(e.target.checked);
                              setMotivos({
                                ...motivos,
                                checkMalaExperiencia: e.target.checked ? 1 : 0,
                              });
                            }}
                          />
                          <span className="checkmark" />
                        </label>
                      </div>
                      <div
                        className={`u-border-all--grey-lighter u-padding ${
                          !showOption2 ? 'u-display-none' : ''
                        }`}
                      >
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="checkgroup checkgroup__block">
                          {t('datos.baja.shop-online')}

                          <input
                            type="checkbox"
                            id="tienda"
                            checked={
                              motivos.checkMalaExperienciaTiendaOnline !== 0 &&
                              showOption2
                            }
                            onChange={(e) =>
                              handlerChange(e, 'MalaExpTiendaOnline')
                            }
                          />
                          <span className="checkmark" />
                        </label>

                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="checkgroup checkgroup__block">
                          {t('datos.baja.movil-app')}

                          <input
                            type="checkbox"
                            id="aplicacion"
                            checked={
                              motivos.checkMalaExperienciaApp !== 0 &&
                              showOption2
                            }
                            onChange={(e) => handlerChange(e, 'MalaExpApp')}
                          />
                          <span className="checkmark" />
                        </label>

                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="checkgroup checkgroup__block">
                          {t('datos.baja.web')}

                          <input
                            type="checkbox"
                            id="web"
                            checked={
                              motivos.checkMalaExperienciaWeb !== 0 &&
                              showOption2
                            }
                            onChange={(e) => handlerChange(e, 'MalaExpWeb')}
                          />
                          <span className="checkmark" />
                        </label>

                        <div className="checkbox">
                          <label
                            className="checkgroup checkgroup__block otros"
                            htmlFor="otros3"
                          >
                            {t('datos.baja.others')}
                            <input
                              type="checkbox"
                              id="otros3"
                              className="open"
                              readOnly
                              checked={
                                motivos.checkMalaExperienciaOtros !== 0 &&
                                showOption2
                              }
                              onChange={(e) => handlerChange(e, 'MalaExpOtros')}
                              onClick={() => {
                                setInternalOption2(!showInternalOption2);
                              }}
                            />
                            <span className="checkmark" />
                          </label>
                        </div>

                        <div
                          className={`text-otros-motivos u-padding-top ${
                            !showInternalOption2 ? 'u-display-none' : ''
                          }`}
                        >
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label className="hidden">
                            {t('datos.baja.others-motives')}
                          </label>
                          <span className="num-caracteres">
                            {cadena2.length}/300
                          </span>
                          <textarea
                            className="textarea"
                            id="otros-motivos-2"
                            maxLength={300}
                            placeholder={t('datos.baja.tell-us')}
                            cols={100}
                            rows={4}
                            value={cadena2}
                            onChange={(event) => {
                              ContarLetras(event, 2);
                              setMotivos({
                                ...motivos,
                                textMalaExperienciaOtros: event.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>

                      <div className="checkbox">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="checkgroup label--background">
                          {t('datos.baja.to-many-com')}
                          <input
                            type="checkbox"
                            id="motivo-three"
                            checked={motivos.checkDemasiadaComunicacion !== 0}
                            onChange={(e) =>
                              handlerChange(e, 'DemasiadaComunicacion')
                            }
                          />
                          <span className="checkmark" />
                        </label>
                      </div>

                      <div className="checkbox">
                        <label
                          className="checkgroup label--background"
                          htmlFor="motivo-four"
                        >
                          {t('datos.baja.no-share-personal-data')}
                          <input
                            type="checkbox"
                            id="motivo-four"
                            checked={motivos.checkDatosPersonales !== 0}
                            onChange={(e) =>
                              handlerChange(e, 'DatosPersonales')
                            }
                          />
                          <span className="checkmark" />
                        </label>
                      </div>

                      <div className="checkbox">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="checkgroup label--background">
                          {t('datos.baja.others')}
                          <input
                            type="checkbox"
                            id="motivo-five"
                            className="open"
                            readOnly
                            checked={showOption5}
                            onChange={(e) => {
                              setShowOption5(!showOption5);
                              handlerChange(e, 'OtrosMotivos');
                            }}
                          />
                          <span className="checkmark" />
                        </label>
                      </div>

                      <div
                        className={`text-otros-motivos u-border-all--grey-lighter u-padding ${
                          !showOption5 ? 'u-display-none' : ''
                        }`}
                      >
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label className="hidden" htmlFor="otros-motivos-3">
                          {t('datos.baja.other-motives')}
                        </label>
                        <span className="num-caracteres">
                          {cadena3.length}/300
                        </span>
                        <textarea
                          className="textarea"
                          id="otros-motivos-3"
                          maxLength={300}
                          placeholder={t('datos.baja.tell-us')}
                          cols={100}
                          rows={4}
                          value={cadena3}
                          onChange={(event) => {
                            ContarLetras(event, 3);
                            setMotivos({
                              ...motivos,
                              checkOtrosMotivos: showOption5 ? 1 : 0,
                              textOtrosMotivos: event.target.value,
                            });
                          }}
                        />
                      </div>

                      <div className="u-text-right u-margin-top u-margin-bottom">
                        <a
                          href="#baja"
                          className="btn btn-secundary u-margin-right-large"
                          onClick={() => {
                            GuardarNoBaja();
                          }}
                        >
                          {t('datos.baja.i-think-better')}
                        </a>
                        <button
                          id="baja-confirm-btn"
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            DarBaja();
                          }}
                        >
                          {t('datos.baja.confirm')}
                        </button>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </section>{' '}
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default EncuestaForm;
